import { InputLabel } from '@/components/input-label';
import { Spinner } from '@/components/spinner';

import styles from './Select.module.css';

interface SelectProps {
  label?: string | null;
  name: string;
  onChange: React.ChangeEventHandler<HTMLSelectElement>;
  required?: boolean;
  disabled?: boolean;
  selected?: string | number;
  options: {
    value: string | number;
    display?: string | number | null;
  }[];
  isLoading?: boolean;
}

export function Select({
  name,
  label,
  onChange,
  required,
  disabled,
  selected,
  options = [],
  isLoading = false
}: SelectProps) {
  const selectId = `select-${name}`;

  return (
    <label data-testid="selectLabel" className={styles.select} htmlFor={selectId}>
      {label && <InputLabel label={label} required={required} />}

      <select
        className={styles.selectElement}
        data-testid="selectComponent"
        onChange={onChange}
        required={required}
        disabled={disabled}
        value={selected}
        name={name}
        id={selectId}
      >
        {options.map((option) => (
          <option key={`option-${option.value}`} value={option.value}>
            {option.display || option.value}
          </option>
        ))}
      </select>

      {isLoading && (
        <div className={styles.selectLoader} data-testid="spinner">
          <Spinner />
        </div>
      )}
    </label>
  );
}
